/**
 * Tonnie staff only (`isTonnieStaff`): anyone else is sent to the dashboard.
 * The API refuses them too (`@RequireTonnieStaff()`, 403) — this keeps the
 * portal from offering a page whose every read would be refused.
 */
import { useEffect, useRef, type ReactNode } from 'react';
import { useLocation } from 'wouter';

import { isTonnieStaff } from '@/core/config/tonnie-staff';
import { useAuth } from '@/core/contexts/AuthContext';
import { LoadingSpinner } from '@/components/shell/LoadingSpinner';

export function TonnieStaffRoute({ children }: { children: ReactNode }) {
  const { user, isLoading } = useAuth();
  const [, setLocation] = useLocation();
  const redirected = useRef(false);
  const staff = isTonnieStaff(user);
  const known = !isLoading && user !== null && user?.role !== undefined;

  useEffect(() => {
    if (known && !staff && !redirected.current) {
      redirected.current = true;
      setLocation('/dashboard');
    }
  }, [known, staff, setLocation]);

  if (!known || !staff) return <LoadingSpinner />;
  return <>{children}</>;
}
